import { render, staticRenderFns } from "./PassedInsurance.vue?vue&type=template&id=270a1702"
import script from "./PassedInsurance.vue?vue&type=script&lang=js"
export * from "./PassedInsurance.vue?vue&type=script&lang=js"
import style0 from "./PassedInsurance.vue?vue&type=style&index=0&id=270a1702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports